export function len_valid(val) {
  // 限制长度1-10
  if (!val || val.length < 1 || val.length > 6) {
    return { valid: false, msg: "长度1-6位" };
  }
  return { valid: true };
}

export const input_valid = {
  //不可点击遮罩层关闭
  closeOnClickModal: false,
  // 用于element-ui的prompt的Input验证，使用到本文件的len_valid函数, 一般用于名称
  inputValidator: $value => {
    let resp = len_valid($value);
    if (!resp.vaild) {
      return resp.msg;
    }
  }
};
export default {
  len_valid,
  input_valid
};



// WEBPACK FOOTER //
// ./src/utils/validate.js